<script setup lang="ts">
import type { TimeEntry } from '~/types/timeEntry.type'
import { format } from 'date-fns'

const props = defineProps({
  title: {
    type: String,
    default: 'Wirklich beginnen?',
  },
  timeEntry: {
    type: Object as PropType<TimeEntry<'withTask' | 'withProject'>>,
    required: true,
  },
})

defineEmits<{
  close: [boolean]
}>()

const startAtFormatted = computed(() => {
  return format(props.timeEntry?.startAt || Date.now(), 'dd.MM.yy \'um\' HH:mm \'Uhr\'')
})
</script>

<template>
  <ConfirmModal :title="title" confirm-text="Beginnen" @close="$emit('close', $event)">
    <slot />
    <template #body>
      <div>
        Es läuft bereits ein Zeiteintrag für die Aufgabe <span class="font-semibold">{{ timeEntry.task.name }}</span> seit dem <span class="font-semibold">{{ startAtFormatted }}</span>.
      </div>
      <div>
        Soll der neue Zeiteintrag wirklich begonnen werden?
      </div>
    </template>
  </ConfirmModal>
</template>
